'use strict';

const body = $('body');
const wind = $(window);
const bodyHTML = $('body, html');

/* ======================================
  c-news1
  ====================================== */
$('.c-news1').each(function () {
  new Swiper($('.c-news1__wrap', this).get(0), {
    loop: true,
    slidesPerView: 1,
    paginationClickable: true,
    direction: 'vertical',
    speed: 1000,
    autoplay: {
      delay: 6000,
    },
    navigation: {
      nextEl: $('.swiper-button-next', this).get(0),
      prevEl: $('.swiper-button-prev', this).get(0),
    },
  });
});

/* ======================================
Header
====================================== */
let scrollPosi;

function bodyFix() {
  scrollPosi = $(window).scrollTop();

  body.addClass('is-fixed').css({ top: -scrollPosi });
}

function bodyFixReset() {
  body.removeClass('is-fixed').css({ top: '0' });

  bodyHTML.scrollTop(scrollPosi);
}

(() => {
  const btn = $('.js-menu');
  const content = $('.c-header__content');
  const btnSubMenu = $('.js-show-menuSub');

  wind.on('load resize', function () {
    setTimeout(
      () =>
        wind.outerWidth() < 768 && content.css('transition', '.3s ease-in-out'),
      500,
    );

    wind.outerWidth() > 767 && content.removeAttr('style');
  });

  if (btn.length) {
    btn.on('click', function () {
      const header = $(this).parents('.c-header');
      const header_content = header.find('.c-header__content');

      $(this).toggleClass('is-active');
      header_content.toggleClass('is-active');
      header.toggleClass('is-menu-open');

      if (header_content.hasClass('is-active')) {
        bodyFix();
      } else {
        bodyFixReset();
      }

      if (wind.innerHeight() < $('.c-header__content__inner').innerHeight()) {
        header_content.removeClass('d-flex');
      }
    });

    $(window).bind('pageshow', function (event) {
      if (event.originalEvent.persisted) {
        $('.c-header__content').addClass('is-hide');
        resetMenuHeader();

        setTimeout(() => {
          $('.c-header__content').removeClass('is-hide');
        }, 0);
      }
    });
  }

  wind.on('resize', () => {
    if (wind.innerHeight() < $('.c-header__content__inner').innerHeight()) {
      $('.c-header__content').removeClass('d-flex');
    } else {
      $('.c-header__content').addClass('d-flex');
    }
  });
  btnSubMenu.on('click', function () {
    $(this).toggleClass('is-active');
    $(this).next().slideToggle(300);
  });

  $('.js-list1txt').matchHeight();
  $('.js-list8txt').matchHeight();
  $('.js-list8txt1').matchHeight();


})();

function resetMenuHeader() {
  $('.js-menu').removeClass('is-active');
  $('.c-header__content').removeClass('is-active');
  $('.c-header').removeClass('is-menu-open');
  bodyFixReset();
}

//Back To Top
$('.c-scrollTop').on('click', function (e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: 0 }, 1000);
});

// -----------------------------
if ($('.p-top').length) {
  $(window).on('load', function (e) {
    setTimeout(function () {
      $('.p-top1 .p-top__title').appendTo('.p-top1');
    }, 2000);
    $('.p-top1__box').width($('.p-top1__box').width());
    $('.p-top1__box').height($('.p-top1__box').height());
    $('.p-top2__head').width($('.p-top2 .p-top__title').width());
    $('.p-top2__head').height($('.p-top2 .p-top__title').height());
    let pos_top = $('.p-top1 .p-top__title').offset().top;
    let pos_left = $('.p-top1 .p-top__title').offset().left;
    $('.p-top1 .p-top__title , .p-top2 .p-top__title').css({top: pos_top,left: pos_left,position: 'fixed',});
    $(window).on('scroll', function (e) {
      if ($(this).scrollTop() + pos_top > $('.p-top2__head').offset().top) {
        $('.p-top1 .p-top__title').addClass('is-hide');
        $('.p-top2 .p-top__title').removeAttr("style");
      } else {
        $('.p-top1 .p-top__title').removeClass('is-hide');
        $('.p-top2 .p-top__title').css({top: pos_top,left: pos_left,position: 'fixed',});
      }

      // if ($('.c-sidebar').offset().top > $('.p-top1').position().top + $('.p-top1').outerHeight(true) - $('.c-sidebar').height()) {
      //   $('.js-sidebar').addClass('is-hide');
      // } else {
      //   $('.js-sidebar').removeClass('is-hide');
      // }
    });
  });
  $(window).on('resize', function (e) {
    $('.p-top1 .p-top__title').css({
      left: $('.p-top2 .p-top__title').offset().left,
    });
  });
}
// -----------------------------
$(window).on('load', function (e) {
  AOS.init({
    once: true,
    duration: 800,
  });
});
// -----------------------------
$('a[href*=\\#]:not([href=\\#])').click(function () {
  if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
    location.hostname == this.hostname
  ) {
    let $target = $(this.hash);
    $target =
      ($target.length && $target) || $('[name=' + this.hash.slice(1) + ']');
    let offsetTop = $('.c-header').outerHeight();
    if ($target.length) {
      let targetOffset = $target.offset().top - offsetTop;
      $('html,body').animate({ scrollTop: targetOffset }, 1000);
      return false;
    }
  }
});

$(function () {
  let slide1 = $('.js-slide1');
  if (slide1.length) {
    slide1.each(function () {
      let _this = $('.c-slide1__slide', this);

      new Swiper(_this[0], {
        loop: true,
        observer: true,
        watchOverflow: true,
        updateOnWindowResize: true,
        speed: 800,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: $('.swiper-pagination', this).get(0),
          type: 'progressbar',
        },
        mousewheel: {
          sensitivity: 1,
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            slidesToShow: 1,
            spaceBetween: 0,
          },
          769: {
            slidesToShow: 2,
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1281: {
            slidesToShow: 3,
            slidesPerView: 3,
            spaceBetween: 70,
          },
        },
        navigation: {
          nextEl: $('.swiperslide1-button-next', this).get(0),
          prevEl: $('.swiperslide1-button-prev', this).get(0),
        },
      });
    });
  }
  $('.js-slide1txt1').matchHeight();
  $('.js-slide1txt').matchHeight();
});

// if ($('.js-sidebar').length) {
//   $(window).on('scroll', function () {
//     $('.js-sidebar').removeClass('is-view');
//   });
// }

$('.js-zoomimg').hover(
  function () {
    $(this).parents('.js-fade__inner').addClass('is-zoom');
    // c-list4
    $(this).parents('.c-list4__item').find('.c-list4__img').addClass('is-zoom');
  },
  function () {
    $(this).parents('.js-fade__inner').removeClass('is-zoom');
    // c-list4
    $(this)
      .parents('.c-list4__item')
      .find('.c-list4__img')
      .removeClass('is-zoom');
  },
);

/* ======================================
  c-faq
  ====================================== */
  $(function () {
    $('.c-faq__que').on('click', function () {
      $(this).toggleClass('is-open')
      $(this).next('.c-faq__an').slideToggle();
    });
  });
